// Fiche de suivi patient — données bilingues FR/ES + options d'activités.

export const CABINET = {
  name: "M2HAT PSYCHOLOGIE",
  tagline: "BILAN COGNITIF · ÉVALUATION ET SUIVI THÉRAPEUTIQUE",
  cabinet: "CABINET M2HAT PSYCHOLOGIE",
  mail: "mounir.hatti@m2hat-psychologie.fr",
  siren: "98916461100018",
  rpps: "10008555145",
  praticien: "Mounir HATTI",
  titre: "psychologue",
};

export const ACT_FONDAMENTALES = [
  { key: "drivers", fr: "Drivers relationnels", es: "Drivers relacionales" },
  { key: "distorsions", fr: "Distorsions cognitives", es: "Distorsiones cognitivas" },
  { key: "schemas", fr: "Schémas de pensée", es: "Esquemas de pensamiento" },
  { key: "besoins", fr: "Besoins psychologiques", es: "Necesidades psicológicas" },
  { key: "bilan_general", fr: "Bilan général", es: "Balance general" },
];

export const ACT_SPEC1 = [
  { key: "angoisse", fr: "Angoisse", es: "Angustia" },
  { key: "addiction", fr: "Addiction", es: "Adicción" },
  { key: "tsa", fr: "TSA", es: "TEA" },
  { key: "toc", fr: "TOC", es: "TOC" },
];

export const ACT_SPEC2 = [
  { key: "estime", fr: "Estime de soi", es: "Autoestima" },
  { key: "emotions", fr: "Gestion des émotions", es: "Gestión de las emociones" },
  { key: "metacognition", fr: "Métacognition", es: "Metacognición" },
  { key: "coping", fr: "Stratégies de coping", es: "Estrategias de afrontamiento" },
];

export const ACT_SPEC3 = [
  { key: "couple", fr: "Thérapie de couple", es: "Terapia de pareja" },
  { key: "guidage_parental", fr: "Guidage parental", es: "Orientación parental" },
];

export const THEME_SUGGESTIONS = {
  fr: ["Anxiété", "Estime de soi", "Gestion des émotions", "Relations", "Communication", "Stress", "Confiance en soi", "Sommeil", "Motivation", "Affirmation de soi"],
  es: ["Ansiedad", "Autoestima", "Gestión de las emociones", "Relaciones", "Comunicación", "Estrés", "Confianza en uno mismo", "Sueño", "Motivación", "Asertividad"],
};

export const emptyActivities = () => ({ items: {}, custom: [], commentaire: "" });

export const emptyFiche = () => ({
  info: { site: "", dispositif: "", libre: "" },
  sessions: [],
  motif: "",
  objectifs: { general: "", items: [] },
  thematiques: { current: { themes: [], commentaire: "", objectifProchaine: "" }, history: [] },
  fondamentales: emptyActivities(),
  specifiques1: emptyActivities(),
  specifiques2: emptyActivities(),
  specifiques3: emptyActivities(),
  programme: [],
  recap: "",
  bilan: { evolution: "", progres: "", difficultes: "", objectifsPoursuivre: "", recommandations: "", prochaineEtape: "" },
});

export const PRIORITES = [
  { key: "haute", fr: "Haute", es: "Alta" },
  { key: "moyenne", fr: "Moyenne", es: "Media" },
  { key: "basse", fr: "Basse", es: "Baja" },
];

// Modèles d'attestation. Le corps légal reste en français (identité fixe M2HAT).
export const ATTEST_TYPES = [
  { key: "consultation", fr: "Attestation de consultation", es: "Certificado de consulta",
    title: "ATTESTATION DE CONSULTATION", body: "atteste avoir reçu en consultation :" },
  { key: "presence", fr: "Attestation de présence", es: "Certificado de asistencia",
    title: "ATTESTATION DE PRÉSENCE", body: "atteste que la personne désignée ci-dessous s'est présentée en consultation :" },
  { key: "prise_en_charge", fr: "Attestation de prise en charge", es: "Certificado de atención",
    title: "ATTESTATION DE PRISE EN CHARGE", body: "atteste assurer la prise en charge de :" },
];

export const FICHE_T = {
  fr: {
    pageTitle: "Fiches de suivi patient",
    pageIntro: "Créez et suivez les fiches de vos patients. Ces données sont archivées de façon confidentielle et ne sont visibles que par vous.",
    newPatient: "Nouvelle fiche patient",
    listEmpty: "Aucune fiche pour le moment. Créez votre première fiche patient.",
    searchPlaceholder: "Rechercher un patient par nom…",
    noSearchResult: "Aucun patient ne correspond à votre recherche.",
    remindersTitle: "Prochaines séances & priorités",
    noReminders: "Aucune séance à venir ni objectif prioritaire pour le moment.",
    nextSession: "Prochaine séance",
    upcomingSessions: "séance(s) à venir",
    priorityObjectives: "Objectifs prioritaires",
    nextObjective: "Objectif prochaine séance",
    open: "Ouvrir",
    delete: "Supprimer",
    confirmDelete: "Supprimer définitivement cette fiche ?",
    sessionsCount: "séance(s)",
    lastUpdate: "Modifiée le",
    back: "← Toutes les fiches",
    backDashboard: "← Tableau de bord",
    save: "Enregistrer",
    saving: "Enregistrement…",
    saved: "Fiche enregistrée",
    saveError: "Échec de l'enregistrement",
    loading: "Chargement…",
    unnamed: "(sans nom)",
    // sections
    s1: "1. Informations patient",
    s2: "2. Suivi des séances",
    s3: "3. Motif de la demande",
    s4: "4. Objectifs du suivi",
    s5: "5. Thématiques prioritaires",
    s6: "6. Activités fondamentales",
    s7: "7. Activités spécifiques (1)",
    s8: "8. Activités spécifiques (2)",
    s9: "9. Activités spécifiques (3)",
    s10: "10. Récapitulatif des activités réalisées",
    s11: "11. Bilan général",
    s12: "12. Attestation",
    // 1
    nom: "Nom",
    prenom: "Prénom",
    site: "Site",
    dispositif: "Dispositif",
    champLibre: "Champ libre",
    // 2
    addSession: "Ajouter une séance",
    sessionDate: "Date et heure",
    sessionNote: "Note de séance",
    removeSession: "Supprimer",
    noSessions: "Aucune séance enregistrée.",
    sessionsRealises: "Séances réalisées",
    // 3
    motifPlaceholder: "Pourquoi le patient consulte-t-il ?",
    // 4
    objGeneral: "Objectif général",
    addObjectif: "Ajouter un objectif",
    objTherapeutique: "Objectif thérapeutique",
    activitesATravailler: "Activités à travailler",
    priorite: "Niveau de priorité",
    // 5
    thematiquesWarning: "Cette rubrique est actualisée après chaque séance. L'ancienne version est conservée dans l'historique et n'est pas écrasée.",
    addTheme: "Ajouter",
    themePlaceholder: "Thématique personnalisée…",
    suggestions: "Suggestions",
    themeComment: "Commentaire / éléments à reprendre",
    objectifProchaine: "Objectif de la prochaine séance",
    archiveTheme: "Actualiser après séance (archiver)",
    themeHistory: "Historique des thématiques",
    archivedAt: "Archivé le",
    noHistory: "Aucun historique pour le moment.",
    selectedThemes: "Thématiques prioritaires",
    // activities
    personnalisation: "Personnalisation / commentaire",
    itemNote: "Personnalisation / commentaire",
    addCustom: "Ajouter « Autre »",
    customLabel: "Intitulé",
    sectionComment: "Commentaire général de la rubrique",
    remove: "Supprimer",
    // 10
    addActivity: "Ajouter une activité",
    activityLabel: "Activité",
    activityObjectif: "Objectif",
    activityConsignes: "Consignes",
    moveUp: "Monter",
    moveDown: "Descendre",
    programmeEmpty: "Aucune activité dans le programme.",
    recapPlaceholder: "Récapitulez ici les activités réalisées au fil des séances…",
    recapAuto: "Générer depuis les activités cochées",
    recapNoActivities: "Aucune activité cochée dans les rubriques 6 à 9.",
    // 11
    evolution: "Évolution",
    progres: "Progrès",
    difficultes: "Difficultés persistantes",
    objectifsPoursuivre: "Objectifs à poursuivre",
    recommandations: "Recommandations",
    prochaineEtape: "Prochaine étape",
    // 12
    genAttestation: "Générer une attestation de suivi",
    attestNote: "Génération immédiate du PDF (impression navigateur). Aucun archivage automatique.",
    attestType: "Type d'attestation",
    exportFiche: "Exporter la fiche (PDF)",
    fichePrintTitle: "Fiche de suivi patient",
    empty: "—",
    dob: "Date de naissance",
    dateRealisee: "Date réalisée",
    datesRealisees: "Date(s) de consultation réalisée(s)",
    addDate: "Ajouter une date",
    plannedDates: "Prochaine(s) date(s) planifiée(s) (optionnel)",
    datesRealiseesPrinted: "Date(s) réalisée(s) :",
    plannedDatesPrinted: "Prochaine(s) date(s) planifiée(s) :",
    removeDate: "Retirer",
    signatureLabel: "Signature du praticien (image)",
    signatureAdd: "Importer une signature",
    signatureRemove: "Retirer la signature",
    signatureHint: "L'image reste sur votre appareil, elle n'est pas archivée.",
    signatureDate: "Date de la signature",
    signedOn: "Fait le",
    printPdf: "Imprimer / PDF",
    downloadPdf: "Télécharger le PDF (sans lien)",
    closeAttest: "Fermer",
    attestTitle: "ATTESTATION DE CONSULTATION",
    attestBody: "atteste avoir reçu en consultation :",
    attestSigned: "Je soussigné,",
    attestLegal: "La présente attestation est établie pour servir et valoir ce que de droit.",
    attestRequest: "À la demande de l'intéressé(e)",
    attestSignature: "Signature",
    bornLe: "né(e) le",
  },
  es: {
    pageTitle: "Fichas de seguimiento del paciente",
    pageIntro: "Cree y realice el seguimiento de las fichas de sus pacientes. Estos datos se archivan de forma confidencial y solo son visibles para usted.",
    newPatient: "Nueva ficha de paciente",
    listEmpty: "No hay fichas por el momento. Cree su primera ficha de paciente.",
    searchPlaceholder: "Buscar un paciente por nombre…",
    noSearchResult: "Ningún paciente coincide con su búsqueda.",
    remindersTitle: "Próximas sesiones y prioridades",
    noReminders: "Ninguna sesión próxima ni objetivo prioritario por el momento.",
    nextSession: "Próxima sesión",
    upcomingSessions: "sesión(es) próxima(s)",
    priorityObjectives: "Objetivos prioritarios",
    nextObjective: "Objetivo de la próxima sesión",
    open: "Abrir",
    delete: "Eliminar",
    confirmDelete: "¿Eliminar definitivamente esta ficha?",
    sessionsCount: "sesión(es)",
    lastUpdate: "Modificada el",
    back: "← Todas las fichas",
    backDashboard: "← Panel",
    save: "Guardar",
    saving: "Guardando…",
    saved: "Ficha guardada",
    saveError: "Error al guardar",
    loading: "Cargando…",
    unnamed: "(sin nombre)",
    s1: "1. Información del paciente",
    s2: "2. Seguimiento de las sesiones",
    s3: "3. Motivo de la consulta",
    s4: "4. Objetivos del seguimiento",
    s5: "5. Temáticas prioritarias",
    s6: "6. Actividades fundamentales",
    s7: "7. Actividades específicas (1)",
    s8: "8. Actividades específicas (2)",
    s9: "9. Actividades específicas (3)",
    s10: "10. Resumen de las actividades realizadas",
    s11: "11. Balance general",
    s12: "12. Certificado",
    nom: "Apellido",
    prenom: "Nombre",
    site: "Centro",
    dispositif: "Dispositivo",
    champLibre: "Campo libre",
    addSession: "Añadir una sesión",
    sessionDate: "Fecha y hora",
    sessionNote: "Nota de sesión",
    removeSession: "Eliminar",
    noSessions: "Ninguna sesión registrada.",
    sessionsRealises: "Sesiones realizadas",
    motifPlaceholder: "¿Por qué consulta el paciente?",
    objGeneral: "Objetivo general",
    addObjectif: "Añadir un objetivo",
    objTherapeutique: "Objetivo terapéutico",
    activitesATravailler: "Actividades a trabajar",
    priorite: "Nivel de prioridad",
    thematiquesWarning: "Esta sección se actualiza después de cada sesión. La versión anterior se conserva en el historial y no se sobrescribe.",
    addTheme: "Añadir",
    themePlaceholder: "Temática personalizada…",
    suggestions: "Sugerencias",
    themeComment: "Comentario / elementos a retomar",
    objectifProchaine: "Objetivo de la próxima sesión",
    archiveTheme: "Actualizar tras la sesión (archivar)",
    themeHistory: "Historial de temáticas",
    archivedAt: "Archivado el",
    noHistory: "Ningún historial por el momento.",
    selectedThemes: "Temáticas prioritarias",
    personnalisation: "Personalización / comentario",
    itemNote: "Personalización / comentario",
    addCustom: "Añadir «Otro»",
    customLabel: "Título",
    sectionComment: "Comentario general de la sección",
    remove: "Eliminar",
    addActivity: "Añadir una actividad",
    activityLabel: "Actividad",
    activityObjectif: "Objetivo",
    activityConsignes: "Consignas",
    moveUp: "Subir",
    moveDown: "Bajar",
    programmeEmpty: "Ninguna actividad en el programa.",
    recapPlaceholder: "Resuma aquí las actividades realizadas a lo largo de las sesiones…",
    recapAuto: "Generar a partir de las actividades marcadas",
    recapNoActivities: "Ninguna actividad marcada en las secciones 6 a 9.",
    evolution: "Evolución",
    progres: "Progresos",
    difficultes: "Dificultades persistentes",
    objectifsPoursuivre: "Objetivos a continuar",
    recommandations: "Recomendaciones",
    prochaineEtape: "Próxima etapa",
    genAttestation: "Generar un certificado de seguimiento",
    attestNote: "Generación inmediata del PDF (impresión del navegador). Sin archivado automático.",
    attestType: "Tipo de certificado",
    exportFiche: "Exportar la ficha (PDF)",
    fichePrintTitle: "Ficha de seguimiento del paciente",
    empty: "—",
    dob: "Fecha de nacimiento",
    dateRealisee: "Fecha realizada",
    datesRealisees: "Fecha(s) de consulta realizada(s)",
    addDate: "Añadir una fecha",
    plannedDates: "Próxima(s) fecha(s) planificada(s) (opcional)",
    datesRealiseesPrinted: "Date(s) réalisée(s) :",
    plannedDatesPrinted: "Prochaine(s) date(s) planifiée(s) :",
    removeDate: "Quitar",
    signatureLabel: "Firma del profesional (imagen)",
    signatureAdd: "Importar una firma",
    signatureRemove: "Quitar la firma",
    signatureHint: "La imagen permanece en su dispositivo, no se archiva.",
    signatureDate: "Fecha de la firma",
    signedOn: "Fait le",
    printPdf: "Imprimir / PDF",
    downloadPdf: "Descargar el PDF (sin enlace)",
    closeAttest: "Cerrar",
    attestTitle: "ATTESTATION DE CONSULTATION",
    attestBody: "atteste avoir reçu en consultation :",
    attestSigned: "Je soussigné,",
    attestLegal: "La présente attestation est établie pour servir et valoir ce que de droit.",
    attestRequest: "À la demande de l'intéressé(e)",
    attestSignature: "Signature",
    bornLe: "né(e) le",
  },
};
